const FEATURE_FLAGS = {
  PROPOSALS: "proposals",
  ENABLE_WITHDRAWAL: "pwa_enable_withdrawal",
  SUPPLIER_INFO: "pwa_enable_supplier_info",
};

export default FEATURE_FLAGS;
